module.exports = __webpack_public_path__ + "static/media/footer-facebook.90b12f72.svg";